<template>
  <div>
    <div id="titleInfo">
      微信支付
    </div>
    <div>
      <div v-if="userPayStatus == false">
        <img
          :src="baseURL + getERCode + '/' + scId + '/' + randomNum"
          alt="由于网络原因无法获取付款二维码, 请检查网络"
        />
      </div>
      <div v-else id="paySuccessPan" class="el-icon-success">
        支付成功 !
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['checkTradeIntervalAddressEvent'],
  props: {
    scId: Number
  },
  data () {
    return {
      baseURL: '',
      getERCode: '/placeAnOrder',
      checkValidate: '/checkValidate',
      randomNum: Math.floor(Math.random() * 100),
      userPayStatus: false,
      intervalAddress: null
    }
  },
  mounted () {
    this.baseURL = '/md/front/shoppingCart/payType/weixin'
    clearInterval(this.intervalAddress) // 清除上一个定时器
    // 监听用户是否付款的事件
    this.intervalAddress = setInterval(this.checkUserHasPaiedOrNot, 1000)
    this.$emit('checkTradeIntervalAddressEvent', this.intervalAddress)
  },
  methods: {
    checkUserHasPaiedOrNot () {
      // 检查一次当前用户是否付款
      const api = this.baseURL + this.checkValidate
      let params = {
        shoppingCartId: this.scId
      }
      params = this.$qs.stringify(params) // 将json格式的内容转换为拼接的字符串, 发送方式还是post
      const that = this
      this.axios.post(api, params).then(res => {
        if (res.status === 200 && res.data) {
          that.userPayStatus = true
          clearInterval(that.intervalAddress) // 清除定时器
          this.$notify('付款成功, 5秒后跳转到账户页面')
          setTimeout(() => {
            this.$router.push('/userCenter/info').catch(() => {})
          }, 5000)
        } else {
          console.log('用户当前未付款')
        }
      })
    }
  }
}
</script>

<style scoped>
#titleInfo {
  color: #fff;
  font-size: 20px;
}

#paySuccessPan {
  height: 100px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  padding-top: 50px;
  padding-bottom: 30px;
  font-size: 22px;
  color: crimson;
}
</style>
